const store = require("@/store").default;
const eb = require("@/services/eventBus");
const is_localhost = require("@/utils").default.is_localhost;
const customLogger = require("@/utils").customLogger;

if (is_localhost() || process.env.NODE_ENV == "test")
  window.cleed_store_GUID = process.env.VUE_APP_STORE_GUID;

const specsSites = {
  "94ab44cb-a042-4da2-89fb-7fb436b8c1e1": {
    // intermarche
    _MATOMO_SITE_ID: null,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
    "https://storage.googleapis.com/cleed-datacenter-europe/intermarche/logointermarche.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "45b9f381-c011-4157-93b1-426b6e7daa4f": {
    // relaisColis
    _MATOMO_SITE_ID: null,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
    "https://storage.googleapis.com/cleed-datacenter-europe/relaiscolis/realiscolislogo.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "330386c1-c905-4c86-b072-ae5d3b447bc0": {
    // Cdiscount
    _MATOMO_SITE_ID: null,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
    "https://storage.googleapis.com/cleed-datacenter-europe/Cdiscount/LogoCdiscount1.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "5882a95a-4c38-4951-95b1-79ada201aa41": {
    // sisley
    _MATOMO_SITE_ID: 28,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
    "https://storage.googleapis.com/cleed-datacenter-europe/sisley/sisley.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },

  "3ad09965-ad54-4088-9cb6-0d72ecc3a289": {
    // vente unique
    _MATOMO_SITE_ID: null,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
    "https://storage.googleapis.com/cleed-datacenter-europe/Vente%20Unique/VenteUniqueLogo.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },

   "c0c3716c-77c5-4af6-a91d-d67880ee19c8": {
    // club med
    _MATOMO_SITE_ID: null,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
    "https://storage.googleapis.com/cleed-datacenter-europe/ClubMed/club%20med%20logo.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },

  "5d191289-2d38-4d2f-b984-9634bb2a458b": {
    // Courbevoie
    _MATOMO_SITE_ID: null,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
    "https://storage.googleapis.com/cleed-datacenter-europe/courbevoie/courbevoie-logo.jpg",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "0b17a293-a68c-47a3-94fa-ac6a57b655d2": {
    // RUEIL
    _MATOMO_SITE_ID: 24,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
    "https://storage.googleapis.com/cleed-datacenter-europe/Rueil/rueil.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "7b550506-2caa-4704-8a74-4054979180f2": {
    // ARBS
    _MATOMO_SITE_ID: undefined,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Arbs/arbs.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "5ab8962a-f8d5-46b6-8bd4-49cff07b7fdf": {
    //MFK
    _SITE_URL: "https://www.avrilgau.com/",
    _MATOMO_SITE_ID: 7,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/mfk/logo_mfk.png",
    TERMS_URL:
       null,
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "9a8e9c08-c924-462d-b731-339783c7d001": {
    //AVRILGAU
    _SITE_URL: "https://www.avrilgau.com/",
    _MATOMO_SITE_ID: 7,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: tracking_avrilgau,
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/avrilgau/avatar_avrilgau.png",
    TERMS_URL:
      "https://www.avrilgau.com/en/content/3-terms-and-conditions-of-use",
    _CSS_PRODUCT_GRID_CONTAINER: "js-product-list",
    _CSS_PRODUCT_GRID: ".subimage-true",
    _CSS_ADD_TO_CART: ".add-to-cart",
    _CSS_PRODUCT_REF: ".h1",
    _CSS_CHECKOUT_FORM: ".checkout",
    _CSS_PAYEMENT_FORM: "#payment-confirmation",
    _CSS_PAYEMENT_VALIDATE: null,
    _CSS_PRODUCT_REMOVED_CART: ".remove-from-cart",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "0c2fa2b9-e266-4d51-9721-1bbf78e6469e": {
    _MATOMO_SITE_ID: 5,
    _CLOSE_ICON: "keyboard_arrow_down",
    _NO_CHAT: true,
    _REGEX_PRODUCT_PAGE_URL: new RegExp(
      "/https://www.departementfeminin.com/(fr|en)/produit/.*/"
    ),
    _REGEX_ADD_TO_CART_REQUEST: new RegExp(
      "/https://www.departementfeminin.com/(fr|en)/add-panier.php"
    ),
    _CSS_PRODUCT_GRID: "div.elementor-section-wrap",
    _CSS_ADD_TO_CART: "#add-basket",
    _CSS_PROCEED_TO_CHECKOUT: "#btnValid",
    _CSS_PAYMENT_CONFIRM: "a.validerPaiement",
    _CSS_PRODUCT_REF: null,
    _FUNCTION_TRACKING: tracking,
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/departement/logo_chat2.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "4dfd938d-bbbd-4e0c-ad94-fba81801f32e": {
    //FRAICHE
    _MATOMO_SITE_ID: 4,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: tracking,
    _IMG_LOGO:
      "https://www.fraiche-paris.fr/wp-content/uploads/2019/07/fraiche_logo_noir_normal.png",
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/fraiche/F2.png",
    _CSS_PRODUCT_GRID_CONTAINER: undefined,
    _CSS_PRODUCT_GRID: undefined,
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "2a1ca459-4745-4d0f-a304-0339740e00ba": {
    // DESIGN PRIVES
    _MATOMO_SITE_ID: undefined,
    _FUNCTION_TRACKING: tracking,
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/designprives/Ally4.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
    TERMS_URL: undefined,
    _CSS_PRODUCT_GRID_CONTAINER: "product-miniature",
    _CSS_PRODUCT_GRID: ".product-thumbnail",
    _CSS_ADD_TO_CART: ".add-to-cart",
    _CSS_PRODUCT_REF: ".product-reference",
    _CSS_CHECKOUT_FORM: ".checkout",
    _CSS_PAYEMENT_FORM: ".payment-confirmation",
    _CSS_PAYEMENT_VALIDATE: null,
    _CSS_PRODUCT_REMOVED_CART: ".remove-from-cart",
  },
  "eaa619b9-f144-4dc9-a22d-21f8c38764a4": {
    // TEMPS DES CERISES
    _MATOMO_SITE_ID: undefined,
    _FUNCTION_TRACKING: tracking,
    _IMG_AVATAR:
      "https://www.letempsdescerises.com/media/favicon/default/favicon-64x64-1.png",
    TERMS_URL: undefined,
    _CSS_PRODUCT_GRID_CONTAINER: "products-list",
    _CSS_PRODUCT_GRID: "product-image-item",
    _CSS_ADD_TO_CART: "#product-addtocart-button",
    _CSS_PRODUCT_REF: ".product-name",
    _CSS_CHECKOUT_FORM: ".btn-proceed-checkout",
    _CSS_PAYEMENT_FORM: ".pl-pay-btn",
    _CSS_PAYEMENT_VALIDATE: null,
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "9a65be57-74c3-470c-b1c8-fa9193fcd78b": {
    // STAGING
    _MATOMO_SITE_ID: 1,
    _FUNCTION_TRACKING: tracking,
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/departement/chat online4.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/manfield/Conseillere-min.png",
    TERMS_URL: undefined,
  },
  "97734cac-9057-4e15-b214-1be423c791a3": {
    // OLLYGAN
    _MATOMO_SITE_ID: undefined,
    _FUNCTION_TRACKING: tracking,
    _IMG_AVATAR:
      "https://www.ollygan.com/static/version1582109632/frontend/Ollygan/OllyganTheme/fr_FR/Magento_Theme/favicon.ico", // OK
    TERMS_URL: undefined,
    _CSS_PRODUCT_GRID_CONTAINER: "product-items",
    _CSS_PRODUCT_GRID: ".product-item-photo",
    _CSS_ADD_TO_CART: "#product-addtocart-button",
    _CSS_PRODUCT_REF: ".product-reference",
    _CSS_CHECKOUT_FORM: ".checkout",
    _CSS_PAYEMENT_FORM: ".checkout",
    _CSS_PAYEMENT_VALIDATE: null,
    _CSS_PRODUCT_REMOVED_CART: null,
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "8g1ca459-4745-4d0f-a304-0339740e11bz": {
    // Manfield
    _MATOMO_SITE_ID: 8,
    _FUNCTION_TRACKING: tracking,
    _CLOSE_ICON: "close",
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/manfield/Manbow.svg",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/manfield/WhatsApp%20Image%202020-11-03%20at%2011.43.46.jpeg",
    TERMS_URL: undefined,
    _CSS_PRODUCT_GRID_CONTAINER: ".product-list", // grille ou les produits sont
    _CSS_PRODUCT_GRID: "#thumbnail-product", // lien du produit
    _CSS_ADD_TO_CART: ".cart-box-content", // buton ajout au panier
    _CSS_PRODUCT_REF: ".product-details__ref", // reference ou le nom
    _CSS_CHECKOUT_FORM: ".process-button-next-step", // bouton pour valider les infos
    _CSS_PAYEMENT_FORM: "a.payment-step__axepta-cta", // bouton pour payez une fois carte rentré
    _CSS_PAYEMENT_VALIDATE: null,
    _CSS_PRODUCT_REMOVED_CART: ".cart__line-actions--remove",
    _DEV_MODE_DATALAYER_INDEX: 1,
    _DATALAYER_PATH: "window.dataLayer[1]['ecommerce']['detail'].products[0]",
    _CSS_OPEN_MODAL_ID: "#cleed_size_reco_manfield",
    _PRODUCT_FORM_NAME: "product-content",
    _RGDP_COOKIE_NAME: "rbsWebsiteTrackerConsentGdpr"
  },
  "649bebc9-b8c6-4983-ad36-474b11d2d66f": {
    //Anahide
    _MATOMO_SITE_ID: 10,
    _FUNCTION_TRACKING: tracking,
    _CLOSE_ICON: "keyboard_arrow_down",
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Anahide/logo.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
    TERMS_URL: undefined,
    _CSS_PRODUCT_GRID_CONTAINER: "ProductList-grid",
    _CSS_PRODUCT_GRID: ".ProductList-item-link",
    _CSS_ADD_TO_CART: ".sqs-add-to-cart-button-inner",
    _CSS_PRODUCT_REF: ".ProductItem-details-title",
    _CSS_CHECKOUT_FORM: ".checkout-button",
    _CSS_PAYEMENT_FORM: ".CheckoutSection-continueButton-10GdB",
    _CSS_PAYEMENT_VALIDATE: null,
    _CSS_PRODUCT_REMOVED_CART: ".item-remove",
  },
  "74083bca-67d4-4b2c-9327-cf4d4dfd6c1c": {
    //Dada
    _MATOMO_SITE_ID: 11,
    _FUNCTION_TRACKING: tracking,
    _CLOSE_ICON: "keyboard_arrow_down",
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/dada/Logo%20DADA.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
    TERMS_URL: undefined,
    _CSS_PRODUCT_GRID_CONTAINER: "products",
    _CSS_PRODUCT_GRID: ".woocommerce-loop-product__link",
    _CSS_ADD_TO_CART: ".single_add_to_cart_button",
    _CSS_PRODUCT_REF: ".qodef-single-product-title",
    _CSS_CHECKOUT_FORM: ".checkout-button",
    _CSS_PAYEMENT_FORM: "#place_order",
    _CSS_PAYEMENT_VALIDATE: null,
    _CSS_PRODUCT_REMOVED_CART: ".remove",
  },
  "c6afa06b-04f0-4c04-8987-f59377dfeb1e": {
    // ZENITH
    _MATOMO_SITE_ID: undefined,
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/zenith/Logo%20Z.png",
    _FUNCTION_TRACKING: tracking,
    TERMS_URL: "https://www.zenith-watches.com/fr_fr/page/privacy-policy",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "5e2153b7-a3f8-431d-b84a-7ce57e0cdcf2": {
    // FETE
    _MATOMO_SITE_ID: 9,
    _IMG_AVATAR:
      "https://cdn.shopify.com/s/files/1/2441/0509/files/logo-footer_large.jpg?v=1509626090",
    _ADMIN_IMG_AVATAR:
      "https://cdn.shopify.com/s/files/1/2441/0509/files/logo-footer_large.jpg?v=1509626090",
    _FUNCTION_TRACKING: tracking_FI,
    _CLOSE_ICON: "keyboard_arrow_down",
    TERMS_URL: "https://www.feteimperiale.fr/pages/terms-conditions",
    _CSS_PRODUCT_GRID_CONTAINER: "product-list",
    _CSS_PRODUCT_GRID: ".product-info__caption",
    _CSS_ADD_TO_CART: ".add_to_cart",
    _CSS_PRODUCT_REF: ".product_name",
    _CSS_CHECKOUT_FORM: ".step__footer__continue-btn",
    _CSS_PAYEMENT_FORM: null,
    _CSS_PAYEMENT_VALIDATE: null,
    _CSS_PRODUCT_REMOVED_CART: ".product-minus",
  },
  // "3d2d5b2f-24c8-4699-b227-9c303db37355": {
  //   // L'EXCEPTION
  //   _MATOMO_SITE_ID: 12,
  //   _CUSTOM_CIRCLE: "Circle_lexception",
  //   _FUNCTION_TRACKING: tracking,
  //   _IMG_AVATAR:
  //     "https://storage.googleapis.com/cleed-datacenter-europe/lexception/Logo%20L'Exception%202.png",
  //   _CLOSE_ICON: "keyboard_arrow_down",
  //   _NO_CHAT: true,
  //   TERMS_URL: undefined,
  //   _CSS_PRODUCT_GRID_CONTAINER: null,
  //   _CSS_PRODUCT_GRID: ".article-item",
  //   _CSS_ADD_TO_CART: ".product-add-to-cart",
  //   _CSS_PRODUCT_REF: ".product-title",
  //   _CSS_CHECKOUT_FORM: "#link_3",
  //   _CSS_PAYEMENT_FORM: ".checkout-buttons > div > button",
  //   _CSS_PAYEMENT_VALIDATE: null,
  //   _CSS_PRODUCT_REMOVED_CART: ".btn-remove",
  //   _ADMIN_IMG_AVATAR:
  //     "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  // },
  "de3abad2-222f-4f86-ac8d-c2cf32803a1b": {
    // ANJA
    _MATOMO_SITE_ID: 13,
    _FUNCTION_TRACKING: tracking_anja,
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Anja/Logo.png",
    _CLOSE_ICON: "keyboard_arrow_down",
    TERMS_URL: undefined,
    _CSS_PRODUCT_GRID_CONTAINER: ".collection__grid--container",
    _CSS_PRODUCT_GRID: ".product__item--container",
    _CSS_ADD_TO_CART: "button.button__plain.add-to-cart",
    _CSS_PRODUCT_REF: "h1.product-single__title",
    _CSS_CHECKOUT_FORM: "button.cart__checkout",
    _CSS_PAYEMENT_FORM: null,
    _CSS_PAYEMENT_VALIDATE: null,
    _CSS_PRODUCT_REMOVED_CART:
      "button.js-qty__adjust--minus,span.minus__quantity",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "d563b6ec-4cba-4c4f-a4c8-3b35b2d4d685": {
    // L'EXCEPTION2
    _MATOMO_SITE_ID: 12,
    _CUSTOM_CIRCLE: "Circle_lexception",
    _FUNCTION_TRACKING: tracking,
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/lexception/Logo%20L'Exception%202.png",
    _CLOSE_ICON: "keyboard_arrow_down",
    _NO_CHAT: true,
    TERMS_URL: undefined,
    _CSS_PRODUCT_GRID_CONTAINER: null,
    _CSS_PRODUCT_GRID: ".article-item",
    _CSS_ADD_TO_CART: [ "#btn-addtocart" ],
    _CSS_PRODUCT_REF: ".product-title",
    _CSS_CHECKOUT_FORM: "#link_3",
    _CSS_PAYEMENT_FORM: [ "https://www.lexception.com/fr-fr/checkout-confirmation?commande=", "https://www.lexception.com/fr-en/checkout-confirmation?commande=", "https://www.lexception.com/fr-de/checkout-confirmation?commande="],
    _CSS_PAYEMENT_VALIDATE: null,
    _CSS_PRODUCT_REMOVED_CART: ".btn-remove",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
    _DATALAYER_PATH: "window.cleedDataLayer",
    _PRODUCT_FORM_NAME: "cleed_size_reco_lexception",
    _SIZE_ADVICE_BUTTON_TEXT_COLOR: "#FFFFFF"
  },
  "03376e2e-6b52-41b4-90a0-72861ba5c785": {
    // JACK GOMME
    _SITE_URL: "https://www.jackgomme.com/",
    _MATOMO_SITE_ID: 14,
    _FUNCTION_TRACKING: tracking,
    _CLOSE_ICON: "keyboard_arrow_down",
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/jackgomme/logo.jpg",
    TERMS_URL: "https://www.jackgomme.com/fr/cgv/",
    _CSS_PRODUCT_GRID_CONTAINER: "div.ligne,ligne-products",
    _CSS_PRODUCT_GRID: "div.product",
    _CSS_ADD_TO_CART: "button.single_add_to_cart_button",
    _CSS_PRODUCT_REF: "div.product-ref",
    _CSS_CHECKOUT_FORM: "a.woocommerce-button",
    _CSS_PAYEMENT_FORM: "#payment-confirmation",
    _CSS_PAYEMENT_VALIDATE: null,
    _CSS_PRODUCT_REMOVED_CART: '[data-action="minus"]',
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "dd3fb7b1-7b62-4cd0-b8a6-40bc5a847e96": {
    // L'EXCEPTION STAGING
    _MATOMO_SITE_ID: undefined,
    _CUSTOM_CIRCLE: "Circle_lexception",
    _FUNCTION_TRACKING: tracking,
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/lexception/Logo%20L'Exception%202.png",
    _CLOSE_ICON: "keyboard_arrow_down",
    _NO_CHAT: true,
    TERMS_URL: undefined,
    _CSS_PRODUCT_GRID_CONTAINER: null,
    _CSS_PRODUCT_GRID: ".article-",
    _CSS_ADD_TO_CART: ".product-add-itemto-cart",
    _CSS_PRODUCT_REF: ".product-title",
    _CSS_CHECKOUT_FORM: "#link_3",
    _CSS_PAYEMENT_FORM: ".checkout-buttons > div > button",
    _CSS_PAYEMENT_VALIDATE: null,
    _CSS_PRODUCT_REMOVED_CART: ".btn-remove",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "60d64a2d-8013-4d0b-b611-8c551f7bd603": {
    // GILIS
    _MATOMO_SITE_ID: 15,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: tracking,
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/gilis/Logo_carr%C3%A9.png",
    _NO_CHAT: true,
    TERMS_URL: undefined,
    _CSS_PRODUCT_GRID_CONTAINER: "#products",
    _CSS_PRODUCT_GRID: "article.product-miniature",
    _CSS_ADD_TO_CART: ".add-to-cart",
    _CSS_PRODUCT_REF: ".head_title",
    _CSS_CHECKOUT_FORM: "div.checkout",
    _CSS_PAYEMENT_FORM: "#payment-confirmation",
    _CSS_PAYEMENT_VALIDATE: null,
    _CSS_PRODUCT_REMOVED_CART: ".remove-from-cart",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "ff0a1670-59f6-46c9-b730-4d5ef49738c5": {
    //GOOSEBERRY
    _MATOMO_SITE_ID: undefined,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/gooseberry/gooseberry_avatar.jpg",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "2fea2328-a6c7-4a2f-9458-63097c8fead6": {
    // OSERÉE
    _MATOMO_SITE_ID: undefined,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/os%C3%A9r%C3%A9e/Ose%CC%81ree.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },

  "6524601b-0f40-4825-953e-a98c55f2e4ab": {
    // Yeu Voyajes
    _MATOMO_SITE_ID: undefined,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/yeuvoyages/LogoYeuVoyages.png",
  },
  "49bef24e-3bcc-42c7-8af4-9b5b6f4bdaf8": {
    //BAUME ET MERCIER
    _MATOMO_SITE_ID: undefined,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/baume_et_mercier/baume_et_mercier.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "fbffdb77-508c-45b3-aec0-ed3bc7a9bb0b": {
    // CLEED.AI
    _MATOMO_SITE_ID: undefined,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/cleed_ai/cleedAiv2.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "c14fbf91-c8d1-4546-90b4-216020f1e6b9": {
    // NOO PARIS
    _MATOMO_SITE_ID: 20,
    _CLOSE_ICON: "keyboard_arrow_down",
    _CSS_OPEN_MODAL_ID: "#cleed_size_reco",
    _FUNCTION_TRACKING: trackingModal,
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/nooparis/logonooparis.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/nooparis/logonooparis.png",
  },
  "3e2922c4-239b-49e4-a0be-1933d98592b9": {
    // TRENCH AND COAT
    _MATOMO_SITE_ID: undefined,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/trenchandcoat/trenchandcoat.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "fa1b1c21-484d-4125-965a-0ed1a1086f3b": {
    // MANOUSH
    _MATOMO_SITE_ID: undefined,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/mamoush/logo_manoush.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "6762eda4-582d-4505-aa44-3e6e26578289": {
    // CLEED.COM
    _MATOMO_SITE_ID: undefined,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Logo_Cleed_v2.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/cleed.com/box-assets/madame.png",
  },
  "f721cb37-de7f-4e7b-9760-1755cfd670bb": {
    // CARVEN
    _MATOMO_SITE_ID: 19,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: tracking_carven,
    _CSS_ADD_TO_CART: "#product-addtocart-button",
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/carven/logo_carven.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "6bf081e2-0184-4d26-95b3-7474b903a53e": {
    // Sivan
    _MATOMO_SITE_ID: undefined,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Logo_SIVAN.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "35fb94b7-f32d-4234-9cc3-26ce1ef38582": {
    // SivanV2
    _MATOMO_SITE_ID: undefined,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Logo_SIVAN.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "752a18d9-27e1-43a1-b823-c9ef7b6c81f5": {
    // CHANEL
    _MATOMO_SITE_ID: undefined,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/chanel/logo-chanel.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "9f02157e-af26-4a4c-a4e4-ae76e6057af5": {
    // Repossi
    _MATOMO_SITE_ID: undefined,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Repossi/Repossi.jpg",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "26caaafd-3570-454c-9533-6fb45e6f3b1a": {
    // Levallois
    _MATOMO_SITE_ID: undefined,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Levallois/LevalloisLogo.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "f1a5b57e-414a-4efc-9eb5-1947c393a91b": {
    // Mervels
    _MATOMO_SITE_ID: undefined,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Mervels/Mervels.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "2948ab85-18f1-4b9e-93fb-32e20e46bf60": {
    // Smartzer
    _MATOMO_SITE_ID: undefined,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Smartzer/logo.jpeg",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "3a2c23eb-1ccd-4f9b-ae09-c793f335cd39": {
    //FORMACAST
    _SITE_URL: "https://www.formacast.org/",
    _MATOMO_SITE_ID: 23,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: null,
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Formacast/Logo.png",
    __LOGIN_BG: "https://storage.googleapis.com/cleed-datacenter-europe/Formacast/login_bg.jpg",
    TERMS_URL:
      "https://lemandator.immo/admin/tool/policy/viewall.php?returnurl=https%3A%2F%2Flemandator.immo%2F",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Advisor.png",
  },
  "16fcb269-a6d8-47df-88cb-9f362d7428ee": {
    //Insidy
    _SITE_URL: "https://insidy.com/",
    _MATOMO_SITE_ID: undefined,
    _CLOSE_ICON: "keyboard_arrow_down",
    _FUNCTION_TRACKING: () => {},
    _IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Insidy/logo1.png",
    _ADMIN_IMG_AVATAR:
      "https://storage.googleapis.com/cleed-datacenter-europe/Insidy/logo1.png",
  },
};

function elementReady(selector) {
  return new Promise((resolve, reject) => {
    let el = document.querySelector(selector);
    if (el) resolve(el);

    new MutationObserver((mutatuionRecords, observer) => {
      Array.from(document.querySelectorAll(selector)).forEach((element) => {
        resolve(element);
        observer.disconnect();
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  });
}

function addProductTracking() {
  elementReady(
    specsSites[window.cleed_store_GUID]._CSS_PRODUCT_GRID_CONTAINER
  ).then((productCards) => {
    let tmp;

    for (let a = 0; a < productCards.length; a++) {
      productCards[a].setAttribute(
        "id",
        specsSites[window.cleed_store_GUID]._CSS_PRODUCT_GRID_CONTAINER
      );
    }

    tmp = document.getElementById(
      "#" + specsSites[window.cleed_store_GUID]._CSS_PRODUCT_GRID_CONTAINER
    );
    if (tmp) {
      tmp = tmp.querySelectorAll(
        specsSites[window.cleed_store_GUID]._CSS_PRODUCT_GRID
      );
    }

    if (tmp) {
      customLogger("addProductTracking OK");
      for (let a = 0; a < tmp.length; a++) {
        matomoTracker.trackGoal(3);
        tmp[a].setAttribute("data-track-content", "");
        tmp[a].setAttribute("data-content-name", "product_card");
      }
    }
  });
  try{
    const dataLayer = getDatalayerIfExist(specsSites[window.cleed_store_GUID]?._DATALAYER_PATH)
    matomoTracker.trackGoal(3);
    matomoTracker.trackEvent("Site", "Product viewed", dataLayer.id);
    customLogger("Product viewed OK", dataLayer.id);
  }
  catch(e)
  {
    // customLogger( "product not found in dataLayer)");
  }
}

function getDatalayerIfExist(path)
{
  try{
    if (!path)
      throw "path is empty"
    const dataLayer = eval(path)
    if (dataLayer && dataLayer.id)
       return dataLayer;
    throw "dataLayer not found"
  }
  catch(e)
  {
    throw e;
  }
}

function addCartTrackingMatomo()
{
  var refProduct = document.querySelector(
    specsSites[window.cleed_store_GUID]._CSS_PRODUCT_REF
  ).innerText;

  try{
    const dataLayer = getDatalayerIfExist(specsSites[window.cleed_store_GUID]?._DATALAYER_PATH)
    var refProduct = dataLayer.id;
  }
  catch(e)
  {
    // customLogger( "product not found in dataLayer)");
  }

  customLogger("Add to cart detected", refProduct);
  matomoTracker.trackGoal(1);
  matomoTracker.trackEvent("Site", "Add to cart", refProduct);
}

function addCartTracking() {
  if (!Array.isArray(specsSites[window.cleed_store_GUID]._CSS_ADD_TO_CART))
  {
    elementReady(specsSites[window.cleed_store_GUID]._CSS_ADD_TO_CART).then(
      (bouton) => {
        bouton.addEventListener("click", () => {
          addCartTrackingMatomo();
        });
      }
    );
  }
  else
  {
    document.querySelectorAll(specsSites[window.cleed_store_GUID]._CSS_ADD_TO_CART[0]).forEach((e, i) => {
      e.addEventListener("click", () => {
        customLogger('Add to cart ', i + 1)
        addCartTrackingMatomo();
      });
   });
  }
}

function addCheckoutFormTracking() {
  elementReady(specsSites[window.cleed_store_GUID]._CSS_CHECKOUT_FORM).then(
    (bouton) => {
      bouton.addEventListener("click", () => {
        customLogger("addCheckoutFormTracking OK");
        matomoTracker.trackGoal(2);
        matomoTracker.trackEvent("Site", "Proceed to checkout");
      });
    }
  );
}

function isLinkStartWithArray(array) {
  var currentUrl = window.location.href;
  for (let i = 0; i < array.length; i++) {
    // customLogger("isLinkStartWithArray", array[i], " ", currentUrl.startsWith(array[i]))
    if (currentUrl.startsWith(array[i])) {
      return true;
    }
  }
  return false;
}

function addPaymentFormTrackingMatomo()
{
  customLogger("addPaymentFormTracking OK");
  matomoTracker.trackGoal(4);
  matomoTracker.trackEvent("Site", "Payement Form");
}

function addPaymentFormTracking() {
  // if you insert an array with links inside, it will check if the url of the visited page starts as the links in the array and will track the event if it is the case
  if (!Array.isArray(specsSites[window.cleed_store_GUID]._CSS_PAYEMENT_FORM)) {
    elementReady(specsSites[window.cleed_store_GUID]._CSS_PAYEMENT_FORM).then(
      (buton) => {
          buton.addEventListener("click", () => {
            addPaymentFormTrackingMatomo();
          });
      }
    );
  }
  else
  {
    if (isLinkStartWithArray(specsSites[window.cleed_store_GUID]._CSS_PAYEMENT_FORM))
    {
      customLogger("link OK")
      addPaymentFormTrackingMatomo();
    }
  }

}

function addPaymentValidateTracking() {
  elementReady(specsSites[window.cleed_store_GUID]._CSS_PAYEMENT_VALIDATE).then(
    (buton) => {
      buton.addEventListener("click", () => {
        customLogger("addPaymentValidateTracking OK");
        matomoTracker.trackGoal(5);
        matomoTracker.trackEvent("Site", "Payement Validated");
      });
    }
  );
}

function addProductRemoveFromCartTracking() {
  elementReady(
    specsSites[window.cleed_store_GUID]._CSS_PRODUCT_REMOVED_CART
  ).then((buton) => {
    buton.addEventListener("click", () => {
      customLogger("addProductRemoveFromCartTracking OK");
      matomoTracker.trackGoal(6);
      matomoTracker.trackEvent("Site", "Remove from cart");
    });
  });
}

function tracking_anja(matomoTracker, intercept) {
  addProductTracking();
  addProductRemoveFromCartTracking();

  var CartContainer = document.getElementById("CartContainer");
  var tracker_result = [];
  var observer = new MutationObserver(function (mutations) {
    customLogger("anja add to cart a change detect");
    var cards = document.getElementsByClassName("ajaxcart__product");
    if (cards.length) {
      const prods = document.getElementsByClassName("grid__item two-thirds");
      for (var i = 0; i < prods.length; i++) {
        if (
          prods[i].querySelector("a") &&
          prods[i].getElementsByClassName(
            "ajaxcart__price text__sans__serif--15 fw--700"
          ).length
        ) {
          const offert =
            prods[i].getElementsByClassName(
              "ajaxcart__price text__sans__serif--15 fw--700"
            )[0].innerText == "OFFERT"
              ? true
              : false;
          const href = prods[i].querySelector("a").href;
          // customLogger(href, offert)
          if (!tracker_result.includes(href) && !offert) {
            matomoTracker.trackGoal(1);
            matomoTracker.trackEvent("Site", "Add to cart", href);
            tracker_result.push(href);
          }
        }
      }
    } else {
      // customLogger('no card created yet')
    }
    // customLogger("prods added to card", tracker_result)
  });
  observer.observe(CartContainer, { childList: true });

  // var CartContainer = document.getElementById('CartContainer');
  // var tracker_result = []
  // var observer = new MutationObserver(function(mutations) {
  //     console.info('add to cart -> change detect')
  //     var cards = document.getElementsByClassName('ajaxcart__product');
  //     if (cards.length){
  //         const prods = document.getElementsByClassName('ajaxcart__product-name--wrapper')
  //         for (var i = 0; i < prods.length; i++) {
  //             const href = prods[i].querySelector('a').href;
  //             matomoTracker.trackGoal(1)
  //             matomoTracker.trackEvent("Site", "Add to cart", href);
  //         }
  //     }
  //     else {
  //         customLogger('no card created yet')
  //     }
  //     customLogger(tracker_result)                                       // im loging the result here for debug
  // });
  // observer.observe(CartContainer, { childList: true });

  intercept("https://www.anja-paris.com/cart?locale=fr", (response) => {
    if (response.status != 200) {
      customLogger("ERROR IN Checkout");
    } else {
      matomoTracker.trackGoal(2);
      matomoTracker.trackEvent("Site", "Proceed to checkout");
    }
  });

  intercept(
    "https://www.anja-paris.com/[0-9]+/checkouts/.+?previous_step=contact_information&step=shipping_method",
    (response) => {
      if (response.status != 200) {
        customLogger("ERROR IN Checkout");
      } else {
        matomoTracker.trackGoal(3);
        matomoTracker.trackEvent("Site", "Validate Payment");
      }
    }
  );
}
/************************
 *                      *
 *     Agrilgau conf    *
 *                      *
 ************************/

const _REGEX_ADD_TO_CART_REQUEST_AVRILGAU = new RegExp(
    "/https://www.avrilgau.com/?rand=[0-9]*$"
  ),
  _CSS_PROCEED_TO_CHECKOUT_AVRILGAU = 'a[title="Commander"]'; // TO VERIFY

function tracking_avrilgau(matomoTracker, intercept) {
  addProductTracking();
  intercept("https://www.avrilgau.com/fr/panier", (response, args, body) => {
    if (response.status != 200) {
      customLogger("ERROR IN PAYMENT");
    } else {
      matomoTracker.trackGoal(1, body.amount);
      matomoTracker.trackEvent("Site", "Add to cart", body.id_product);
    }
  });
  intercept("https://www.avrilgau.com/en/cart", (response, args, body) => {
    if (response.status != 200) {
      customLogger("ERROR IN PAYMENT");
    } else {
      matomoTracker.trackGoal(1, body.amount);
      matomoTracker.trackEvent("Site", "Add to cart", body.id_product);
    }
  });
  intercept("https://www.avrilgau.com/fr/commande", (response) => {
    if (response.status != 200) {
      customLogger("ERROR IN Checkout");
    } else {
      matomoTracker.trackGoal(2);
      matomoTracker.trackEvent("Site", "Proceed to checkout");
    }
  });
  intercept("https://www.avrilgau.com/en/order", (response) => {
    if (response.status != 200) {
      customLogger("ERROR IN Checkout");
    } else {
      matomoTracker.trackGoal(2);
      matomoTracker.trackEvent("Site", "Proceed to checkout");
    }
  });
  $('a[class="remove-from-cart"]').on("click", () => {
    matomoTracker.trackGoal(6);
    matomoTracker.trackEvent("Site", "Remove from cart");
  });
  for (
    let i = 0;
    store.state.config.selectors && i < store.state.config.selectors.length;
    i++
  ) {
    for (let [key, value] of Object.entries(store.state.config.selectors[i])) {
      // key class name
      const el = document.querySelectorAll(key);

      for (let idxEl = 0; idxEl < el.length; idxEl++) {
        el[idxEl].addEventListener(
          value.tracking_event ? value.tracking_event : "click",
          () => {
            let url = null;
            const tag_a = el[idxEl].querySelector(":scope > a");

            if (tag_a && tag_a.getAttribute("href"))
              url = tag_a.getAttribute("href");
            matomoTracker.trackGoal(store.state.config.selectors[i][key].goal);
            matomoTracker.trackEvent(
              store.state.config.selectors[i][key].event_name,
              store.state.config.selectors[i][key].event_desc
                ? store.state.config.selectors[i][key].event_desc
                : "none",
              url ? url : "none"
            );
          }
        );
      }
    }
  }
}

function tracking_FI(matomoTracker, intercept) {
  addProductTracking();
  intercept("https://feteimperiale.fr/cart/add.js", (response, args, body) => {
    if (response.status != 200) {
      customLogger("Error in add to cart");
    } else {
      body = JSON.parse(response.response);
      eb.emit("AddToCart", body.product_title);
      matomoTracker.trackGoal(1, body.product_id);
      matomoTracker.trackEvent("Site", "Add to cart", body.product_id);
    }
  });
  intercept("www.feteimperiale.fr/checkout/", (response) => {
    if (response.status != 200) {
      customLogger("ERROR IN Checkout");
    } else {
      matomoTracker.trackGoal(2);
      matomoTracker.trackEvent("Site", "Proceed to checkout");
    }
  });
  $('span[class="icon-minus"]').on("click", () => {
    matomoTracker.trackGoal(6);
    matomoTracker.trackEvent("Site", "Remove from cart");
  });
  for (
    let i = 0;
    store.state.config.selectors && i < store.state.config.selectors.length;
    i++
  ) {
    for (let [key, value] of Object.entries(store.state.config.selectors[i])) {
      // key class name
      const el = document.querySelectorAll(key);

      for (let idxEl = 0; idxEl < el.length; idxEl++) {
        el[idxEl].addEventListener(
          value.tracking_event ? value.tracking_event : "click",
          () => {
            let url = null;
            const tag_a = el[idxEl].querySelector(":scope > a");

            if (tag_a && tag_a.getAttribute("href"))
              url = tag_a.getAttribute("href");
            matomoTracker.trackGoal(store.state.config.selectors[i][key].goal);
            matomoTracker.trackEvent(
              store.state.config.selectors[i][key].event_name,
              store.state.config.selectors[i][key].event_desc
                ? store.state.config.selectors[i][key].event_desc
                : "none",
              url ? url : "none"
            );
          }
        );
      }
    }
  }
}

function tracking_carven(tracker, intercept) {
  intercept(
    "https://www.carven.com/fr/checkout/cart/add/",
    (response, args, body) => {
      if (response.status != 200) {
        customLogger("Error in add to cart");
      } else {
        /*intercept(
          "https://www.carven.com/fr/customer/section/load/",
          (response, args, body) => {
            if (response.status != 200) {
              customLogger("Error while loading the cart");
            } else {
              body = JSON.parse(response.response);
              let price = body.cart.subtotalAmount;

              if (price <= 450) {
                customLogger("inferieur");
                eb.emit("AddToCart", price);
              }
            }
          }
        );*/
        eb.emit("AddToCart", "__PRICE_LATER_HERE__");
        tracker.trackGoal(1, "");
        tracker.trackEvent("Site", "Add to cart", "");
      }
    }
  );
  intercept(
    "https://www.carven.com/en/checkout/cart/add/",
    (response, args, body) => {
      if (response.status != 200) {
        customLogger("Error in add to cart");
      } else {
        /*intercept(
          "https://www.carven.com/fr/customer/section/load/",
          (response, args, body) => {
            if (response.status != 200) {
              customLogger("Error while loading the cart");
            } else {
              body = JSON.parse(response.response);
              let price = body.cart.subtotalAmount;

              if (price <= 450) {
                customLogger("inferieur");
                eb.emit("AddToCart", price);
              }
            }
          }
        );*/
        eb.emit("AddToCart", "__PRICE_LATER_HERE__");
        tracker.trackGoal(1, "");
        tracker.trackEvent("Site", "Add to cart", "");
      }
    }
  );
}

function tracking(matomoTracker, intercept) {
  addProductTracking();
  addCartTracking();
  addCheckoutFormTracking();
  addPaymentFormTracking();
  addPaymentValidateTracking();
  addProductRemoveFromCartTracking();
  addOpenModalTracking();
  for (
    let i = 0;
    store.state.config.selectors && i < store.state.config.selectors.length;
    i++
  ) {
    for (let [key, value] of Object.entries(store.state.config.selectors[i])) {
      // key class name
      const el = document.querySelectorAll(key);

      for (let idxEl = 0; idxEl < el.length; idxEl++) {
        el[idxEl].addEventListener(
          value.tracking_event ? value.tracking_event : "click",
          () => {
            let url = null;
            const tag_a = el[idxEl].querySelector(":scope > a");

            if (tag_a && tag_a.getAttribute("href"))
              url = tag_a.getAttribute("href");
            matomoTracker.trackGoal(store.state.config.selectors[i][key].goal);
            matomoTracker.trackEvent(
              store.state.config.selectors[i][key].event_name,
              store.state.config.selectors[i][key].event_desc
                ? store.state.config.selectors[i][key].event_desc
                : "none",
              url ? url : "none"
            );
          }
        );
      }
    }
  }
}

function addOpenModalTracking() {
  if (!specsSites[window.cleed_store_GUID]?._CSS_OPEN_MODAL_ID) return;
  elementReady(
    specsSites[window.cleed_store_GUID]._CSS_OPEN_MODAL_ID
  ).then((button) => {
    button.addEventListener("click", () => {
      customLogger("open modal");
      matomoTracker.trackGoal(7);
      matomoTracker.trackEvent("Site", "Open modal v3");
    });
  });
}

function trackingModal(matomoTracker, intercept) {
  // addProductTracking();
  // addCartTracking();
  // addCheckoutFormTracking();
  // addPaymentFormTracking();
  // addPaymentValidateTracking();
  // addProductRemoveFromCartTracking();
  addOpenModalTracking();
  for (
    let i = 0;
    store.state.config.selectors && i < store.state.config.selectors.length;
    i++
  ) {
    for (let [key, value] of Object.entries(store.state.config.selectors[i])) {
      // key class name
      const el = document.querySelectorAll(key);

      for (let idxEl = 0; idxEl < el.length; idxEl++) {
        el[idxEl].addEventListener(
          value.tracking_event ? value.tracking_event : "click",
          () => {
            let url = null;
            const tag_a = el[idxEl].querySelector(":scope > a");

            if (tag_a && tag_a.getAttribute("href"))
              url = tag_a.getAttribute("href");
            matomoTracker.trackGoal(store.state.config.selectors[i][key].goal);
            matomoTracker.trackEvent(
              store.state.config.selectors[i][key].event_name,
              store.state.config.selectors[i][key].event_desc
                ? store.state.config.selectors[i][key].event_desc
                : "none",
              url ? url : "none"
            );
          }
        );
      }
    }
  }
}

export default {
  ...specsSites[window.cleed_store_GUID],
  _GUID: window.cleed_store_GUID,
};
